import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { GET_URL_BY_ID } from '@utils/api/endpoints.ts';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

export interface CustomerBoSubscription {
  id: number;
  plan_id: number;
  sku: string;
  start_date: string;
  end_date: string;
  cancel_date: string;
  auto_renew: boolean;
  suspended: boolean;
  billing_channel: string;
  azure_subscription_id: null;
  available_stt_budget: null;
  available_stt_units: number;
  available_alignment_budget: null;
  available_alignment_units: number;
  available_translation_budget: null;
  available_translation_characters: null;
  available_custom_models_trained: number;
  custom_model_yearly_limit: number | null;
  custom_model_yearly_used: number;
  custom_model_yearly_remaining: number | null;
}

export type CustomerBoSubscriptionResponse =
  BaseResponse<CustomerBoSubscription>;

export const useGetCustomerBoSubscription = (
  customerId: number,
  subscriptionId: number
) => {
  const { t } = useTranslation();

  const fetchCustomerSubscription = async () => {
    const url = GET_URL_BY_ID(
      String(customerId),
      String(subscriptionId)
    ).customerBoSubscription;

    const { data } = await Axios.get<CustomerBoSubscriptionResponse>(url);
    return data;
  };

  return useQuery<CustomerBoSubscriptionResponse, AxiosError<BaseError>>(
    ['customerBoSubscription', customerId, subscriptionId],
    fetchCustomerSubscription,
    {
      enabled: Boolean(customerId && subscriptionId),
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      onError: error => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const d = error.response?.data as any;
        const msg =
          d?.error_description ||
          d?.detail ||
          d?.error ||
          d?.message ||
          t('an-error-has-occurred');
        toast.error(String(msg));
      }
    }
  );
};
